<template>
    <Header ueberschrift="LP-THL Lernstoff" />
    <div id="lp-thl">
        <h2>Videos:</h2>
        <iframe src="https://www.youtube.com/embed/RYdhBTPMbm4?si=rqfXpuLLZnGFRKTp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <iframe src="https://www.youtube.com/embed/FW2g95lUqXA?si=ZGUWHMiW0L4FRu8C" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <iframe src="https://www.youtube.com/embed/WhqU7J9LQeE?si=7jj26oCFbbIpUNup" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <iframe src="https://www.youtube.com/embed/V8RY1Rdn0q4?si=fpYJ1bwmDml_FQae" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <iframe src="https://www.youtube.com/embed/y0To2u5BnUU?si=eQOlzui2kaAS7V9X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <iframe src="https://www.youtube.com/embed/obQAFfTPgfY?si=YYy9UuGlkrYVFCmF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br>
        <h2>Infos:</h2>
        <h3><a href="https://www.feuerwehr-lernbar.bayern/post/die-gruppe-im-hilfeleistungseinsatz-information" target="_blank">Infos Leistungsprüfung THL</a></h3>
        <br>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'lp-thl',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
#lp-thl{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;

    iframe{
        width: 90vw;
        max-width: 560px;
    }
}
</style>